<template>
    <div class="container-fluid">
        <div class="row py-3">
            <div class="designRowOrga">
                <div class="h3Organization">
                    <h3>Users</h3>
                </div>
                <router-link class="text-decoration-none btn-container"
                             v-if="permissions.includes('create user') && users.length > 0"
                             to="/super/users/create">
                    <span>Create User</span>
                </router-link>
            </div>

            <div class="tabcontent tabcontent-bark-mode">
                <div class="fullInputs mb-4 pt-3">
                    <div class="twoInputs">
                        <div class="btnInsideInput">
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                   placeholder="Search"
                                   @input="searchHandler" maxlength="50">
                            <button @click="searchBackEndHandler(isSearch)">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                        </div>
                    </div>
                    <div class="oneInput">
                        <select id="filter_dates" class="form-select" v-model="sort" @change="filterHandler">
                            <option value="" disabled>Sort by Date</option>
                            <option value="asc" key="1">Oldest</option>
                            <option value="desc" key="2">Latest</option>
                        </select>
                    </div>
                </div>
                <div class="table-container" v-if="users.length > 0">


                    <TableComponent model="users" name="user" :keys="keys" :thead="thead" :tbody="users"
                                    updateUrl="/super/users/edit"
                                    @sort="SortOrganization"
                                    @update="updateOrganization"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="handlePagination($event)" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>
                <div v-else class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
                    <div class="h3Organization">
                        <h3 v-if="!isSearch">You Don't Have Any Users Yet</h3>
                        <h3 v-else>No Data</h3>
                    </div>
                    <router-link class="text-decoration-none btn-container  btn-container-no-data"
                                 v-if="permissions.includes('create user') && users.length === 0 && !isSearch"
                                 to="/super/users/create">
                        <span>Create User</span>
                    </router-link>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
    import repository from "../../../api-services/repository";
    import LaravelVuePagination from 'laravel-vue-pagination';
    import TableComponent from "../../components/TableComponent";

    export default {
        name: 'user-superIndex',
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'super-users');
            this.permissions = this.$store.state.auth.permissions;
            this.getUsers();
            this.$store.dispatch('activeTap', 'super-users');
        },
        data() {
            return {
                users: [],
                permissions: [],
                state: false,
                originalUsers: [],
                thead: ['Username', 'User Email'],
                keys: ['name', 'email'],
                laravelData: {},
                search: '',
                isSearch: false,
                sort: 'desc'
            }
        },
        methods: {
            async getUsers(page = 1) {
                try {
                    let usersData = await repository.index('users', this.search, this.sort === false ? this.sort = 'desc' : this.sort, true, page);
                    this.laravelData = usersData.data.data;
                    this.users = usersData.data.data.data;
                    this.originalUsers = usersData.data.data.data;
                } catch (e) {
                    console.log({e})
                }
            },
            searchHandler(e) {
                this.isSearch = true;
                // let serachedValue = e.target.value.toLowerCase();
                // let searchedData = null;
                // searchedData = this.originalUsers.filter((data) => data.name.toLowerCase().indexOf(serachedValue) >= 0 || data.email.toLowerCase().indexOf(serachedValue) >= 0);
                // this.users = searchedData;
                // if (serachedValue !== '') {
                //     this.isSearch = true;
                // } else {
                //     this.isSearch = false;
                // }
            },
            async searchBackEndHandler(searchFlag = false) {
                // let usersDataLength = this.users.length;
                // if (searchFlag && usersDataLength > 0) {
                    await this.getUsers();
                // }
            },
            filterHandler(e) {
                let filterType = e.target.value;
                if (filterType === 'asc') {
                    this.users.sort(function (a, b) {
                        return new Date(a.created_at) - new Date(b.created_at);
                    });
                } else {
                    this.users.sort(function (a, b) {
                        return new Date(b.created_at) - new Date(a.created_at);
                    });

                }
            },
            async handlePagination(pageNumber) {
                await this.getUsers(pageNumber);
            },
            SortOrganization() {
                let status = !this.state;
                this.originalUsers.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.state = status;
            },
            updateOrganization(e) {
                let filteredData = this.users.filter(function (data) {
                    return data.id != e;
                });
                this.users = filteredData;
                this.getUsers();
            },
        }
    }
</script>

<style scoped>

</style>